import React, { useEffect } from 'react'
import CasinoGameSection from '../../UI-components/Sections/CasinoGamesSection/CasinoGameSection'
import GamificationBlock from '../../UI-components/GamificationBlock/GamificationBlock'
import { WIDGETS } from '../../core/widgets'
import { useAppSelector } from '../../redux/hooks'
import { RootState } from '../../redux/store'
import { LoginStatus } from '../../redux/slices/userSlice'
import { useTranslation } from '../../hooks/useTranslation'
import { Smartico } from '../../core/Smartico'

const HEADER_BANNER_KEY = 'casino-header-placement'
const HEADER_BANNER_DOM_ID = 'casino_header_banner'
const CASINO_BANNER_KEY = 'casino-banner-placement'
const CASINO_BANNER_DOM_ID = 'casino_promo_banner'

const CasinoPage = () => {
	const { loggedIn } = useAppSelector((state: RootState) => state.user)
	const { getTexts } = useTranslation(true)

	useEffect(() => {
		if (loggedIn !== LoginStatus.LoggedIn) return
		let cancelled = false
		Smartico.apiReady.then(() => {
			if (!cancelled) {
				Smartico.lib().showBanner({ placement_key: HEADER_BANNER_KEY, dom_id: HEADER_BANNER_DOM_ID })
				Smartico.lib().showBanner({ placement_key: CASINO_BANNER_KEY, dom_id: CASINO_BANNER_DOM_ID })
			}
		})
		return () => { cancelled = true }
	}, [loggedIn])

	useEffect(() => {
		if (loggedIn !== LoginStatus.LoggedIn) return
		const interval = setInterval(async () => {
			const api = await Smartico.apiReady
			if (!api?.jackpotGet) return
			const jackpots = await api.jackpotGet()
			const jp = jackpots.find((j: any) => j.jp_template_id === 4)
			if (jp) {
				(Smartico.lib() as any).sendDataToBanner({
					placement_key: HEADER_BANNER_KEY,
					data: { jackpot_amount: jp.pot.current_pot_amount, jackpot_currency: jp.jp_currency },
				})
			}
		}, 1000)
		return () => clearInterval(interval)
	}, [loggedIn])

	return (
		<div className="main-content">
			<div id={HEADER_BANNER_DOM_ID} className="header-promo-banner" />
			<CasinoGameSection id="top" category="Top" title={getTexts('top_games')} />
			{loggedIn === LoginStatus.LoggedIn && (
				<GamificationBlock
					domId={WIDGETS.homeNav.domId}
					url={WIDGETS.homeNav.url}
					fit="content"
					className="gamification-block--content"
				/>
			)}
			{loggedIn === LoginStatus.LoggedIn && (
				<GamificationBlock
					domId={WIDGETS.homeJackpot.domId}
					url={WIDGETS.homeJackpot.url}
					fit="content"
					className="gamification-block--content"
				/>
			)}
			{loggedIn === LoginStatus.LoggedIn && (
				<GamificationBlock
					domId={WIDGETS.missions.domId}
					url={WIDGETS.missions.url}
					fit="content"
					className="gamification-block--missions"
				/>
			)}
			<CasinoGameSection id="slots" category="All" title={getTexts('all_games')}/>
			<div id={CASINO_BANNER_DOM_ID} className="casino-promo-banner" />
			{loggedIn === LoginStatus.LoggedIn && (
				<GamificationBlock
					domId={WIDGETS.tournaments.domId}
					url={WIDGETS.tournaments.url}
					fit="content"
					className="gamification-block--content"
				/>
			)}
		</div>
	)
}

export default CasinoPage
